import { useEffect } from 'react'

const Zoom = ({ map, view, position }) => {
  useEffect(() => {
    if (map && view) {
      if (position === 'none') {
        view.ui.remove('zoom')
      } else {
        view.ui.move('zoom', position || 'bottom-right')
      }
    }
  }, [map, view, position])

  return null
}

export default Zoom
